import { InjectionToken } from '@angular/core';

export const SOFTLINE_SETTINGS_APP_OVERVIEW = 'appOverview';
export const SOFTLINE_CONFIG_APP_OVERVIEW = new InjectionToken<AppOverviewConfig>(
  'SOFTLINE_CONFIG_APP_OVERVIEW'
);

export interface AppOverviewConfig {
  defaultView: 'notGrouped' | 'grouped';
  isGroupButtonActive: boolean;
  isModulesSortedByAlphabet: boolean
  isNonPermittedAppsButtonActive: boolean;
  disableNoPermissionApps: boolean;
}
